export const aiPurple = '#7321e8';
export const lightAiPurple = `${aiPurple}24`;
